// @ commons
const { post } = require('services/api');
// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');

const setPDF = pdf => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_PDF,
    payload: pdf,
});

const b64toBlob = (b64Data, typeContent) => {
    const byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512),
            byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: typeContent });

    return blob;
};

const getPDFContract = (accessToken, inlinePdf) => dispatch => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    return post(apiURLBuilder.getURL('raPDFContract'), requestData)
        .then(response => {
            if (inlinePdf) {
                const base64url =
                    URL.createObjectURL(b64toBlob(response.body.generatedPdf, 'Contrato GD.pdf')) +
                    '#toolbar=0&navpanes=0&scrollbar=0';

                dispatch(setPDF(base64url));
            } else {
                dispatch(setPDF(response.body.generatedPdf));
            }
        })
        .catch(error => {
            throw error;
        });
};

export default {
    getPDFContract,
};
